import { forwardRef } from 'react';
import './Input.css';

const Input = forwardRef(({
  type = 'text',
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  hint,
  disabled = false,
  required = false,
  fullWidth = true,
  className = '',
  icon = null,
  iconPosition = 'left',
  ...props
}, ref) => {
  const inputId = id || name;
  const inputClasses = [
    'input-field',
    error ? 'input-error' : '',
    disabled ? 'input-disabled' : '',
    icon ? `input-with-icon input-icon-${iconPosition}` : '',
    fullWidth ? 'input-full-width' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={`input-container ${fullWidth ? 'input-container-full-width' : ''}`}>
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
          {required && <span className="input-required">*</span>}
        </label>
      )}
      
      <div className="input-wrapper">
        {icon && iconPosition === 'left' && (
          <span className="input-icon input-icon-left">{icon}</span>
        )}
        
        <input
          ref={ref}
          type={type}
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={inputClasses}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined}
          {...props}
        />
        
        {icon && iconPosition === 'right' && (
          <span className="input-icon input-icon-right">{icon}</span>
        )}
      </div>
      
      {error && (
        <div id={`${inputId}-error`} className="input-error-message">
          {error}
        </div>
      )}
      
      {hint && !error && (
        <div id={`${inputId}-hint`} className="input-hint">
          {hint}
        </div>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
